import { FunctionComponent } from 'react';
import { PlanFeature } from '../../models/plans.model';
import { UserService } from '../../services/UserService';

interface Props {
    min?: number;
    count: number;
    id?: string;
    max?: number;
    onChange: (count: number, id?: string) => void;
    IsMobileDevice: boolean;
    inverted?: boolean;
    Features?: PlanFeature[];
}

const SettingsCounterComponent: FunctionComponent<Props> = (props: Props) => {

    const handleChange = (count: number) => {
        if (count >= 0 && count <= (props.max || Number.MAX_VALUE)) {
            props.onChange(count, props.id);
        }
    }

    const isCounterEnabled = () => {
        if (!UserService.hasSysAdminRole()) {
            return !props.Features?.filter(x => x?.Label.toLowerCase().includes("10dlc")).length
        }
        else
            return true
    }

    return (
        <div className="number-input-container d-flex align-center">
          <input
            type="number"
            value={props.count}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newCount = parseInt(e.target.value, 10) || 0;
              handleChange(newCount);
            }}
            placeholder="Type a number..."
            className="number-input-field"
            disabled={!isCounterEnabled()}
          />
          <div className="number-input-controls">
            <button
              className= {`number-control-btn ${props.count >= (props.max || Number.MAX_VALUE) ? "-disabled" : ""} bb-primary-divider-1`}
              onClick={(e: any) => { e.preventDefault(); isCounterEnabled() && handleChange(props.count + 1) }}
              disabled={!isCounterEnabled() || props.count >= (props.max || Number.MAX_VALUE)}
            >
              ▲
            </button>
            <button
              className={`number-control-btn`}
              onClick={(e) => {
                e.preventDefault();
                handleChange(props.count - 1);
              }}
              disabled={props.count <= (props.count <= 0 || typeof Number.NEGATIVE_INFINITY === "number" ? Number.NEGATIVE_INFINITY : 0)}
            >
              ▼
            </button>
          </div>
        </div>
      );
}

export default SettingsCounterComponent;